import {StateParams} from 'angular-ui-router';
import {IQService, ILogService} from 'angular';
import {ITranslateService} from 'angular-translate';
import * as moment from 'moment';
import * as _ from 'lodash';

import {IDataValueApi} from '../../../api/data-value-api.service';
import {
    IStation,
    IHydrodataNorm,
    IDataValue
} from '../../../api/api.types';
import {IHydrodataTimeseries, IHydrodataDatum} from '../../../hydromet/timeseries/timeseries.controller';
import {IStationApi} from '../../../api/station-api.service';

interface ITimeseriesStateParams extends StateParams {
  stationId: string;
}

export class TimeseriesGraphController {
  static readonly $inject = ['dataValueApi', '$stateParams',
    'stationApi', '$q', '$log', '$translate', '$rootScope'];
  /**
   * Displayed discharge time series.
   */
  hydrodataTimeseries: IHydrodataTimeseries[];
  /**
   * Station data.
   */
  station: IStation;
  /**
   * Initial year for the discharge data load.
   */
  startYear: number|null;
  /**
   * Final year for the discharge data load.
   */
  endYear: number|null;
  /**
   * Whether there is a loading operation in progress.
   */
  loadingInProgress: boolean;
  /**
   * Discharge measurement pair series.
   */
  private hydrodataSeries: IDataValue[][];
  /**
   * Station ID.
   */
  private stationId: number;
  private hydrodataType: string;

  constructor(private dataValueApi: IDataValueApi,
              $stateParams: ITimeseriesStateParams,
              private stationApi: IStationApi,
              private $q: IQService,
              private $log: ILogService,
              private $translate: ITranslateService,
              private $rootScope: ng.IRootScopeService) {
    this.stationId = Number.parseInt($stateParams.stationId);
    this.startYear = moment().year();
    this.endYear = moment().year();
    this.loadingInProgress = true;
    this.stationApi.getMeteoStation({stationId: this.stationId})
        .then(station => {
          this.station = station;
          this.$rootScope.$broadcast('STATION_LOADED', station);
          return this.loadTimeseries(); 
        });
  }

  loadTimeseries() {
    this.loadingInProgress = true;
    this.hydrodataTimeseries = [];
    const hydrodataPromises = _.range(this.startYear, this.endYear + 1)
        .map(year => this.dataValueApi.getYearDailyAverageData(this.stationId, year, this.hydrodataType));
    this.$q.all(hydrodataPromises)
        .then(hydrodataSeries => {
          this.hydrodataSeries = hydrodataSeries;

          const hydrodataTimeseries: IHydrodataTimeseries[] =
              this.hydrodataSeries
                  .map((hydrodataSeries, index) => {
                    if (hydrodataSeries.length == 0) {
                      return null;
                    }
                    return averageDischargeToDischargeTimeseries(
                        hydrodataSeries, this.startYear + index);
                  })
                  .filter(timeseries => timeseries);
          return this.dataValueApi.getStationNorm(this.stationId, this.hydrodataType)
              .then(hydrodataNorm => {
                hydrodataTimeseries.push(
                    this.hydrodataNormToDischargeTimeseries(hydrodataNorm));
                this.hydrodataTimeseries = hydrodataTimeseries; 
                this.loadingInProgress = false;
              });
        })
        .catch(error => {
          this.$log.error('Error loading ' + this.hydrodataType + ' data.', error);
          this.loadingInProgress = false;
        });
  }

  private hydrodataNormToDischargeTimeseries(hydrodataNorm: IHydrodataNorm): IHydrodataTimeseries {
    return {
      data: hydrodataNorm.normData.map((datum, index) => {
        const month = Math.floor(index / 3);
        const year = month >= 9 ? moment().year() - 1 : moment().year();
        return {
          hydrodata: datum,
          date: moment()
              .year(year)
              .month(month)
              .date((index % 3) * 10 + 5)
              .startOf('day')
        };
      }).sort((datumA, datumB) => {
        if (datumA.date.isBefore(datumB.date)) {
          return -1;
        } else if (datumA.date.isAfter(datumB.date)) {
          return 1;
        }
        return 0;
      }),
      label: this.$translate.instant('HISTORICAL_NORM')
    };
  }

}

function averageDischargeToDischargeTimeseries(this: void,
                                             hydrodataSeries: IDataValue[],
                                             year: number): IHydrodataTimeseries {
  return {
    data: hydrodataSeries.map(avarageHydrodataData => {
      return {
        hydrodata: avarageHydrodataData.dataValue,
        date: moment.unix(avarageHydrodataData.localDateTime)
      };
    }),
    label: `${year}`
  };
}



/** WEBPACK FOOTER **
 ** ./app/meteostation/timeseries/timeseries-graph/timeseries-graph.controller.ts
 **/